<section>
  <app-form-header (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
          @if (senderAddress) {
            <app-postal-address
              [group]="form.controls['senderAddress']"
              [title]="'MAIL_FORM.SENDER_ADDRESS_HEADER'"
              [model]="senderAddress"
              [showName]="true"
              [mandatory]="true"
            ></app-postal-address>
          }
          @if (recipientAddress) {
            <app-postal-address
              [group]="form.controls['recipientAddress']"
              [title]="'MAIL_FORM.RECIPIENT_ADDRESS_HEADER'"
              [model]="recipientAddress"
              [showName]="true"
              [mandatory]="true"
            ></app-postal-address>
          }
        </astral-layout-group>
      </section>
      <section class="astral-section-surface astral-form-stack">
        <astral-input [control]="form.controls['header']"></astral-input>
        <astral-textarea [control]="form.controls['body']" [rows]="16"></astral-textarea>
        <astral-input [control]="form.controls['footer']"></astral-input>
      </section>
      <div class="astral-form-actions">
        <astral-button
          type="button"
          variant="secondary"
          labelKey="PREVIEW_BTN"
          [disabled]="isPreviewDisabled"
          (click)="preview()"
        ></astral-button>
        @if (showSend) {
          <astral-button
            type="button"
            variant="primary"
            labelKey="SEND_BTN"
            [disabled]="isSendDisabled"
            (click)="send()"
          ></astral-button>
        }
      </div>
    </form>
  }
</section>
